/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Language
 */
export interface Language {
    /**
     * 
     * @type {string}
     * @memberof Language
     */
    value: string;
}

/**
 * Check if a given object implements the Language interface.
 */
export function instanceOfLanguage(value: object): value is Language {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function LanguageFromJSON(json: any): Language {
    return LanguageFromJSONTyped(json, false);
}

export function LanguageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Language {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function LanguageToJSON(value?: Language | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
    };
}

